export const reflow = (node) => node.scrollTop

export function getTransitionProps(props, options) {
  const { timeout, style = {} } = props

  return {
    duration:
      style.transitionDuration || typeof timeout === 'number'
        ? timeout
        : timeout[options.mode] || 0,
    delay: style.transitionDelay,
  }
}

/**
 * Returns the height of the TYPO system's header
 */
export const getHeaderHeight = () =>
  document.querySelector('header.header')?.getBoundingClientRect().height || 0 // header query selector for PK header

/**
 * Returns the height of the TYPO system's service menu (bottom) based on CSS classes attached
 * @returns {number}
 */
export const getServiceMenuHeight = () => {
  const serviceMenu = document.getElementsByClassName('serviceArea')
  return serviceMenu.length > 0 ? serviceMenu[0].offsetHeight : 0
}
